import { type ReactElement, type FC, memo } from 'react';
import { useIntl } from './IntlContext.tsx';

type Props = Intl.DateTimeFormatOptions & {
    value: string | Date;
    children?: (result: string) => ReactElement;
};

const FormattedDate: FC<Props> = memo(({ value, children, ...dateTimeOptions }) => {
    const intl = useIntl();
    const result = intl.formatDate(value, dateTimeOptions);
    if (typeof children === 'function') {
        return children(result);
    }
    return <>{result}</>;
});

FormattedDate.displayName = 'FormattedDate';

export { FormattedDate };
